import { useMemo } from 'react';
import { DdbEngagementType } from '@/lib/graphql/types-and-hooks';
import { useEngagementsBase } from './use-engagements-base';

// Dummy data for preview mode
const dummyMeetings = [
  {
    id: '1',
    title: 'Q1 Planning Meeting',
    date: 'Mar 15, 2026',
    attendees: ['John Doe', 'Jane Smith'],
    companies: ['Acme Corp'],
  },
  {
    id: '2',
    title: 'Product Demo',
    date: 'Mar 10, 2026',
    attendees: ['John Doe'],
    companies: ['Acme Corp'],
  },
];

const dummyEmails = [
  {
    id: '1',
    title: 'Re: Project Update',
    from: 'john@example.com',
    date: 'Mar 12, 2026',
    preview: 'Thanks for the update...',
  },
  {
    id: '2',
    title: 'Follow-up on Meeting',
    from: 'john@example.com',
    date: 'Mar 8, 2026',
    preview: 'Just wanted to follow up...',
  },
];

interface UseContactEngagementsOptions {
  contactId: string;
  type?: DdbEngagementType;
  pageSize?: number;
  skip?: boolean;
}

/**
 * Hook for fetching engagements (meetings/emails) associated with a contact
 * Supports pagination and Lovable Preview mode
 */
export const useContactEngagements = ({
  contactId,
  type,
  pageSize = 20,
  skip = false,
}: UseContactEngagementsOptions) => {
  const entityFilter = useMemo(() => ({ contactId }), [contactId]);

  return useEngagementsBase({
    entityFilter,
    entityId: contactId,
    type,
    pageSize,
    skip,
    dummyMeetings,
    dummyEmails,
  });
};
